module.exports = __webpack_public_path__ + "img/left_layout_1.4aceb010.jpg";